/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: "14px",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "A",
    asset: "TÀI SẢN",
    assetBold: true,
    sttBold: true,
    presentReadOnly: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "I",
    sttBold: true,
    asset: "Tiền mặt, vàng bạc, đá quý",
    assetBold: true,
    presentReadOnly: false,
    readOnly: false,
    presentBold: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "II",
    sttBold: true,
    asset: "Tiền gửi tại NHNN",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "III",
    sttBold: true,
    asset: "Tiền gửi cho vay các TCTD khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "1",
    sttBold: false,
    asset: "Tiền gửi tại các TGTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "2",
    sttBold: false,
    asset: "Cho vay các TGTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "3",
    sttBold: false,
    asset: "Dự phòng rủi ro (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "IV",
    sttBold: true,
    asset: "Chứng khoán kinh doanh",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "1",
    sttBold: false,
    asset: "Chứng khoán kinh doanh (1)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "2",
    sttBold: false,
    asset: "Dự phòng rủi ro chứng khoán kinh doanh (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "V",
    sttBold: true,
    asset: "Các công cụ tài chính phái sinh và các tài sản tài chính khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "VI",
    sttBold: true,
    asset: "Cho vay khách hàng",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "1",
    sttBold: false,
    asset: "Cho vay khách hàng",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "2",
    sttBold: false,
    asset: "Dự phòng rủi ro cho vay khách hàng (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "VII",
    sttBold: true,
    asset: "Hoạt động mua nợ",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "1",
    sttBold: false,
    asset: "Mua nợ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: " ", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "2",
    sttBold: false,
    asset: "Dự phòng rủi ro hoạt động mua nợ (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: " ", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "VIII",
    sttBold: true,
    asset: "Chứng khoán đầu tư",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "1",
    sttBold: false,
    asset: "Chứng khoán đầu tư sẵn sàng để bán (2)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "2",
    sttBold: false,
    asset: "Chứng khoán đầu tư giữ đến ngày đáo hạn",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "3",
    sttBold: false,
    asset: "Dự phòng rủi ro chứng khoán đầu tư (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "IX",
    sttBold: true,
    asset: "Góp vốn, đầu tư dài hạn",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "1",
    sttBold: false,
    asset: "Đầu tư vào công ty con",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "2",
    sttBold: false,
    asset: "Vốn góp liên doanh",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "3",
    sttBold: false,
    asset: "Đầu tư vào công ty liên kết",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "4",
    sttBold: false,
    asset: "Đầu tư dài hạn khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "5",
    sttBold: false,
    asset: "Dự phòng giảm giá đầu tư dài hạn (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "X",
    sttBold: true,
    asset: "Tài sản cố định",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "1",
    sttBold: true,
    asset: "Tài sản cố định hữu hình",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "a",
    sttBold: false,
    asset: "Nguyên giá TSCĐ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "b",
    sttBold: false,
    asset: "Hao mòn TSCĐ (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "2",
    sttBold: true,
    asset: "Tài sản cố định thuê tài chính",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "a",
    sttBold: false,
    asset: "Nguyên giá TSCĐ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "b",
    sttBold: false,
    asset: "Hao mòn TSCĐ (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "3",
    sttBold: true,
    asset: "Tài sản cố định vô hình",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "a",
    sttBold: false,
    asset: "Nguyên giá TSCĐ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "b",
    sttBold: false,
    asset: "Hao mòn TSCĐ (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "XI",
    sttBold: true,
    asset: "Bất động sản đầu tư",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "a",
    sttBold: false,
    asset: "Nguyên giá BĐSĐT",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "b",
    sttBold: false,
    asset: "Hao mòn BĐSĐT (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "XII",
    sttBold: true,
    asset: "Tài sản Có khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "1",
    sttBold: false,
    asset: "Các khoản phải thu",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "2",
    sttBold: false,
    asset: "Các khoản lãi, phí phải thu",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 43,
    stt: "3",
    sttBold: false,
    asset: "Tài sản thuế TNDN hoãn lại",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 44,
    stt: "4",
    sttBold: false,
    asset: "Tài sản Có khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 45,
    stt: "",
    sttBold: false,
    asset: "- Trong đó: Lợi thế thương mại",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 46,
    stt: "5",
    sttBold: false,
    asset: "Các khoản dự phòng rủi ro cho các tài sản Có nội bảng khác (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 47,
    stt: "",
    sttBold: true,
    asset: "Tổng tài sản có",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 48,
    stt: "B",
    sttBold: true,
    asset: "Nợ phải trả và vốn chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 49,
    stt: "I",
    sttBold: true,
    asset: "Các khoản nợ Chính phủ và NHNN",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 50,
    stt: "II",
    sttBold: true,
    asset: "Tiền gửi và vay các TCTD khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 51,
    stt: "1",
    sttBold: false,
    asset: "Tiền gửi của các TCTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 52,
    stt: "2",
    sttBold: false,
    asset: "Vay các TCTD khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 53,
    stt: "III",
    sttBold: true,
    asset: "Tiền gửi của khách hàng",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 54,
    stt: "IV",
    sttBold: true,
    asset: "Các công cụ tài chính phái sinh và các khoản nợ tài chính khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 55,
    stt: "V",
    sttBold: true,
    asset: "Vốn tài trợ, ủy thác đầu tư, cho vay TCTD chịu rủi ro",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 56,
    stt: "VI",
    sttBold: true,
    asset: "Phát hành giấy tờ có giá",
    assetBold: true,
    presentReadOnly: false,
    presentBold: true,
    readOnly: false,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 57,
    stt: "VII",
    sttBold: true,
    asset: "Các khoản nợ khác",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 58,
    stt: "1",
    sttBold: false,
    asset: "Các khoản lãi, phí phải trả",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 59,
    stt: "2",
    sttBold: false,
    asset: "Thuế TNDN hoãn lại phải trả",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 60,
    stt: "3",
    sttBold: false,
    asset: "Các khoản phải trả và công nợ khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 61,
    stt: "4",
    sttBold: false,
    asset: "Dự phòng rủi ro khác (Dự phòng cho công nợ tiềm ẩn)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 62,
    stt: "",
    sttBold: false,
    asset: "Tổng nợ phải trả",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 63,
    stt: "VIII",
    sttBold: true,
    asset: "Vốn của chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 64,
    stt: "1",
    sttBold: true,
    asset: "Vốn của TCTD",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 65,
    stt: "a",
    sttBold: false,
    asset: "Vốn điều lệ",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 66,
    stt: "b",
    sttBold: false,
    asset: "Vốn đầu tư XDCB, mua sắm tài sản cố định",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 67,
    stt: "c",
    sttBold: false,
    asset: "Thặng dư vốn cổ phần",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 68,
    stt: "d",
    sttBold: false,
    asset: "Cổ phiếu quỹ (*)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 69,
    stt: "e",
    sttBold: false,
    asset: "Cổ phiếu ưu đãi",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 70,
    stt: "g",
    sttBold: false,
    asset: "Vốn khác",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 71,
    stt: "2",
    sttBold: false,
    asset: "Quỹ của TCTD",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 72,
    stt: "3",
    sttBold: false,
    asset: "Chênh lệch tỷ giá hối đoái (3)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 73,
    stt: "4",
    sttBold: false,
    asset: "Chênh lệch đánh giá lại tài sản",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 74,
    stt: "5",
    sttBold: false,
    asset: "Lợi nhuận chưa phân phối/ Lỗ lũy kế (3)",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 75,
    stt: "6",
    sttBold: false,
    asset: "Lợi ích của cổ đông thiểu số",
    assetBold: false,
    presentReadOnly: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 76,
    stt: "",
    sttBold: false,
    asset: "Tổng nợ phải trả và vốn chủ sở hữu",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 77,
    stt: "",
    sttBold: false,
    asset: "CHỈ TIÊU NGOÀI BẢNG",
    assetBold: true,
    presentReadOnly: false,
    presentBold: false,
    readOnly: true,
    valueBold: true,
    value: { present: "", now: "", before: "" },
  },
];

const dataTableB = [
  {
    id: 0,
    asset: "Bảo lãnh vay vốn",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 1,
    asset: "Cam kết giao dịch hối đoái",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    asset: "Cam kết mua ngoại tệ",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    asset: "Cam kết bán ngoại tệ",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    asset: "Cam kết giao dịch hoán đổi",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    asset: "Cam kết giao dịch tương lai",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    asset: "Cam kết cho vay không hủy ngang",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    asset: "Cam kết trong nghiệp vụ L/C",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    asset: "Bảo lãnh khác",
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    asset: "Cam kết khác",
    value: { present: "", now: 0, before: 0 },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [dataB, setDataB] = useState(dataTableB);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  useEffect(() => {
    setFieldValue("valuesTableB", dataB);
  }, [dataB]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  const handleChangeB = (values) => {
    const { id, name, value } = values;

    setDataB((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic" fontWeight="bold">
          Đơn vị tính: triệu đồng VN
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan={2}>
                STT
              </Th>
              <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
              <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
              <Th style={{ textAlign: "center" }}>Số cuối quý</Th>
              <Th style={{ textAlign: "center" }}>Số đầu năm</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((rows) => (
                <tr key={rows.id}>
                  <Td
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.sttBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.stt}
                  </Td>
                  <Td
                    style={{
                      textAlign: "left",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.assetBold === true ? "bold" : 400,
                    }}
                  >
                    {rows.asset}
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "center",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.presentBold === true ? "bold" : 400,
                    }}
                  >
                    <InputTable2
                      id={rows.id}
                      name="present"
                      readOnly={rows.presentReadOnly}
                      value={rows.value.present}
                      onChange={handleChange}
                      fontWeight={rows.presentBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="now"
                      readOnly={rows.readOnly}
                      value={rows.value.now}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                  <Td
                    colSpan={1}
                    style={{
                      textAlign: "right",
                      background: rows.readOnly === true ? "#ddeff3" : "transparent",
                      fontWeight: rows.readOnly === true ? "bold" : 400,
                    }}
                  >
                    <InputTable
                      id={rows.id}
                      name="before"
                      readOnly={rows.readOnly}
                      value={rows.value.before}
                      onChange={handleChange}
                      fontWeight={rows.valueBold}
                    />
                  </Td>
                </tr>
              ))}
            <tr key={0}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"1"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[0].asset}
              </Td>
              <Td
                colSpan={1}
                rowSpan={10}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable2
                  id={0}
                  name="present"
                  value={dataB[0].value.present}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="now"
                  value={dataB[0].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={0}
                  name="before"
                  value={dataB[0].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={1}>
              <Td
                rowSpan={5}
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"2"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[1].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={1}
                  name="now"
                  readOnly={false}
                  value={dataB[1].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={1}
                  name="before"
                  value={dataB[1].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={2}>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[2].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="now"
                  value={dataB[2].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={2}
                  name="before"
                  value={dataB[2].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={3}>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[3].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={3}
                  name="now"
                  value={dataB[3].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={3}
                  name="before"
                  value={dataB[3].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={4}>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[4].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={4}
                  name="now"
                  value={dataB[4].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={4}
                  name="before"
                  value={dataB[4].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={5}>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[5].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={5}
                  name="now"
                  value={dataB[5].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={5}
                  name="before"
                  value={dataB[5].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={6}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"3"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[6].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={6}
                  name="now"
                  readOnly={false}
                  value={dataB[6].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={6}
                  name="before"
                  value={dataB[6].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={7}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"4"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[7].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={7}
                  name="now"
                  readOnly={false}
                  value={dataB[7].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={7}
                  name="before"
                  value={dataB[7].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={8}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"5"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[8].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={8}
                  name="now"
                  readOnly={false}
                  value={dataB[8].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={8}
                  name="before"
                  value={dataB[8].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
            <tr key={9}>
              <Td
                style={{
                  textAlign: "center",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {"6"}
              </Td>
              <Td
                style={{
                  textAlign: "left",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                {dataB[9].asset}
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={9}
                  name="now"
                  readOnly={false}
                  value={dataB[9].value.now}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
              <Td
                colSpan={1}
                style={{
                  textAlign: "right",
                  background: "transparent",
                  fontWeight: 400,
                }}
              >
                <InputTable
                  id={9}
                  name="before"
                  value={dataB[9].value.before}
                  onChange={handleChangeB}
                  fontWeight={false}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
